import React from "react";
import { Fade } from "reactstrap";
import "react-datepicker/dist/react-datepicker.css";
import "antd/dist/antd.css";
import "@css/components/datePickerDropdown.css";
class ShapeNotif extends React.Component {
  render() {
    let showFade = false;
    if (this.props.shapeNotif) {
      showFade = this.props.shapeNotif;
    }
    return (
      <div id="shape" className={`arh-absolute ${this.props.classParent}`}>
        <Fade in={showFade}>
          <div className={this.props.classArrow}></div>
        </Fade>
      </div>
    );
  }
}

export default ShapeNotif;